import { render, staticRenderFns } from "./HistoryRecord_G.vue?vue&type=template&id=7f8f7373"
import script from "./HistoryRecord_G.vue?vue&type=script&lang=js"
export * from "./HistoryRecord_G.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports